<template>
  <div>
    <errors-messages v-if="use_service" :errors="errors" />
    <div v-if="use_service && !disabled">
      <div v-show="recording">
        <div class="d-flex justify-content-end align-items-center">
          <b-spinner
            type="border"
            class="mr-2"
            style="width: 30px; height: 30px"
            v-show="recording"
            :variant="running ? 'primary' : 'secondary'"
          />
          <v-btn
            v-show="recording"
            small
            class="btn-modern btn-modern-delete ml-2 mr-2"
            @click="abort"
          >
            CANCELAR
          </v-btn>
          <v-btn
            small
            v-show="recording"
            class="btn-modern btn-modern-save ml-2 mr-2"
            @click="stop"
          >
            <i class="fas fa-microphone text-eighteen mr-2"></i> SALVAR
          </v-btn>
        </div>
      </div>
      <div class="text-right" v-show="!recording">
        <v-btn
          small
          v-if="!recording && String(value).length > 0"
          class="btn-modern btn-modern-delete ml-2 mr-2"
          @click="evOnBtnClearClick"
        >
          LIMPAR
        </v-btn>
        <v-btn
          v-show="!recording"
          class="btn-record"
          @click="start"
          style="min-width: 30px !important"
        >
          <i class="fas fa-microphone text-eighteen"></i>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "./ErrorsMessages";

export default {
  name: "ChromeSpeech",

  components: { ErrorsMessages },

  props: {
    disabled: { type: Boolean, default: false },
    label: { type: String, default: undefined },
    value: { type: String, default: "" },
  },

  data() {
    return {
      errors: [],
      loading: false,

      use_service: true,
      recording: false,
      running: false,

      append: true,
      prefix: "",

      /** @type {SpeechRecognition} */
      service: undefined,
    };
  },

  created() {
    this.setup().then();
  },

  methods: {
    async setup() {
      try {
        let SpeechRecognition =
          window.SpeechRecognition || window.webkitSpeechRecognition;
        this.service = new SpeechRecognition();

        this.service.continuous = true;
        this.service.lang = "pt-BR";
        this.service.interimResults = false;
        this.service.maxAlternatives = 1;

        this.service.addEventListener("start", this.evServiceOnStart);
        this.service.addEventListener("end", this.evServiceOnEnd);

        this.service.addEventListener("audiostart", this.evServiceOnAudioStart);
        this.service.addEventListener("audioend", this.evServiceOnAudioEnd);

        this.service.addEventListener("result", this.evServiceOnResult);

        this.service.addEventListener("error", this.evServiceOnError);
      } catch (error) {
        if (error.name == "TypeError") this.use_service = false;

        this.errors = [];
        let message =
          {
            TypeError: "Serviço não suportado",
          }[error.name] || "Ocorreu um erro";
        this.errors.push(message);
      }
    },

    async start() {
      this.service.start();
    },
    async stop() {
      this.service.stop();
    },
    async abort() {
      this.service.abort();
    },

    async evServiceOnStart() {
      this.prefix = this.value;
      this.running = true;
    },
    async evServiceOnEnd() {
      this.prefix = "";
      this.running = false;
    },

    async evServiceOnAudioStart() {
      this.recording = true;
    },
    async evServiceOnAudioEnd() {
      this.recording = false;
    },

    async evServiceOnResult(ev) {
      /**@type {SpeechRecognitionResult} */
      let results = ev.results;
      let output = "";
      for (let result of results) {
        let str = result[0].transcript + ".";
        let start = str.replace(/([\s]*[a-zA-Z]{1})(.*)/, "$1");
        let end = str.replace(/([\s]*[a-zA-Z]{1})(.*)/, "$2");
        output += start.toUpperCase() + end;
      }

      if (this.append && this.prefix) output = this.prefix + " " + output;
      output = output.trim();
      this.$emit("input", output);
    },

    async evServiceOnError(ev) {
      let ignore = {
        aborted: true,
        "no-speech": true,
      }[ev.error];
      if (ignore) return;

      this.errors = [];
      let message =
        {
          "not-allowed": "Uso do microfone bloqueado",
          aborted: "Cancelado",
        }[ev.error] || "Ocorreu um erro";
      this.errors.push(message);
    },

    async evTextareaOnInput(val) {
      this.$emit("input", val);
    },

    async evTextareaOnKeyUp(val) {
      this.$emit("keyup", val);
    },

    async evOnBtnClearClick() {
      this.$emit("input", "");
    },
  },
};
</script>

<style></style>
